<!-- компонент для рисования тарифов в SSL -->
<template><div>
	<div class="wrapper"
	:class="{
		'active': fieldFocused,
		'haserror': fieldError
	}">

		<!-- враппер поля наименование домена -->
		<div class="domains-name-field-wrapper">
			<!-- анимированный заголовок элемента -->
			<div class="w5-field-placeholder"
				:class="{
					'active': fieldFocused || nameValue,
					'readonly': Field.readonly === true || nameField.readonly === true
				}">
				{{ nameField.title | ftc }}<span v-if="nameField.required === true" class="required-field"> *</span>
			</div>
			<!-- наименование домена -->
			<input
				v-model="nameValue"
				type="text"
				placeholder=""
				class="name-field"
				:name="nameField._field_name"
				:ref="nameField._field_name"		
				:disabled="nameField.readonly === true ? 'disabled' : false"
				@paste.prevent="onNamePaste"
				@input="onNameChange"
				@focus="onNameFocus"
				@blur="onNameBlur"
				@keydown.enter="enterKeyDown" />
			<!-- dot -->
			<span class="dot" :class="{ 'active': nameValue }">.</span>
		</div>

		<!-- выбор тарифа -->
		<div class="domains-plan-field-wrapper">
			<multiselect
				v-model="planValue"
				placeholder=""
				label="fullName"
				class="domains-plan-field"
				:options="items && typeof items === 'object' && Array.isArray(items) ? items : []"
				:showLabels="false"
				:allowEmpty="false"
				:searchable="false"	
				:disabled="Field.readonly === true ? true : false"
				:showNoOptions="false"
				@open="onListOpen"
				@close="onListClose"
				@input="onPlanSelect">
				<span slot="option" slot-scope="slotProps" class="domains-plan-option">
					<strong>{{ slotProps.option.name | ftc }}</strong>
					<span v-if="actionValue === 'register'">
						{{ slotProps.option.cost | moneyOnlyNumbers }} <span v-html="localeFtc('main/ruble')"></span> / {{ slotProps.option.period_name | ftc }}
					</span>
					<span v-if="slotProps.option.data && actionValue === 'transfer'">
						{{ slotProps.option.data.Transfer | moneyOnlyNumbers }} <span v-html="localeFtc('main/ruble')"></span>
					</span>
				</span>
				<div slot="singleLabel" slot-scope="slotProps" class="domains-plan-label">
					<template v-if="slotProps.option && slotProps.option.name">
						<div class="name">
							<strong>{{ slotProps.option.name | ftc }}</strong>
						</div>
						<div class="info">
							<div v-if="slotProps.option.cost > 0 && actionValue === 'register'">
								{{ slotProps.option.cost | moneyOnlyNumbers }} <span v-html="localeFtc('main/ruble')"></span> / {{ slotProps.option.period_name | ftc }}
							</div>
							<div v-if="slotProps.option.data && slotProps.option.data.Transfer > 0 && actionValue === 'transfer'">
								{{ slotProps.option.data.Transfer | moneyOnlyNumbers }} <span v-html="localeFtc('main/ruble')"></span>
							</div>
						</div>
					</template>
				</div>
			</multiselect>
		</div>

	</div>

	<!-- сообщение об ошибке, если есть -->
	<div class="wrapper for-error">
		<div v-if="fieldError"
			class="alert alert-danger w5-alert-valid"
			role="alert"
			v-withSafeTags="localeFtc(fieldError)" />	
	</div>

</div></template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Helper from '@/helper/helper'
import Multiselect from 'vue-multiselect'
import debounce from 'debounce'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'planDomainComponent',

	//=========================================================================
	// неизменяемые свойства
	//=========================================================================
	props: [
		'Field',
		'items',
		'nameField',
		'actionField',
		'value'
	],

	//=========================================================================
	// вычисляемые данные
	//=========================================================================
	computed: {
		// есть ли ошибка
		fieldError() {
			// ответ по умолчанию
			let _answer = ''
			// если есть ошибка наименования домена
			if (this.nameField['_errMsg']) _answer = this.nameField['_errMsg']
			// если есть ошибка в тарифе
			if (this.Field['_errMsg']) _answer += (_answer ? ' <br/>' : '') + this.Field['_errMsg']
			// вернем ответ
			return _answer
		}
	},

	//=========================================================================
	// изменяемые свойства
	//=========================================================================
	data() {
		return {
			// текущее значение наименования домена
			nameValue: null,
			// текущее значение тарифа
			planValue: null,
			// текущее значение поля "set_action"
			actionValue: null,
			// поле с фокусом или нет
			fieldFocused: false
		}
	},

	//=========================================================================
	// функция, которыя будет вызвана после создания компонента,
	// но перед монтированием в дом
	//=========================================================================
	created() {
		this.Init()
	},

	//=========================================================================
	//
	//=========================================================================
	mounted() {
		this.parseDomainNameValueDebounce = debounce(this.parseDomainNameValueDebounce, 700)
	},

	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// инициализация значений и списков
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		Init() {
			// текущие значение по умолчанию
			this.nameValue = this.nameField.value
			this.actionValue = this.actionField.value
			this.planValue = null

			// здесь запомним первый элемент списка
			let _firstItem = null
			// если задан список тарифов (могут и не задать)
			if (this.items && this.items.length)
				// ищем значение
				this.items.some(item => {
					// первый элемент
					if (!_firstItem) _firstItem = item
					// ищем в списке заданное значение
					if (this.value === String(item.id))
					{
						this.planValue = item
						return true
					}
				})

			// если значение не найдено, но есть первый элемент списка
			if (_firstItem && !this.planValue)
				this.planValue = _firstItem

			// если у нас есть начальное значение
			if (this.planValue && this.planValue.id) this.$emit('startData', String(this.planValue.id))

			// сообщим родителям
			this.$emit('input', this.planValue && this.planValue.id ? this.planValue.id : null)
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// обработчик изменения наименования домена
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onNameChange() {
			// всегда приводим к нижнему регистру
			this.nameValue = this.nameValue.toLowerCase()
			// сообщаем родителям
			this.$emit('onDomainName', this.nameValue)

			// парсим доменное имя
			this.parseDomainNameValueDebounce(this.nameValue)
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// обработчик получение фокуса полем наименование домена
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onNameFocus() {
			// фокус
			this.fieldFocused = true
			// сообщаем родителям
			this.$emit('focus')
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// обработчик потери фокуса полем наименование домена
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onNameBlur() {
			// потеря фокуса
			this.fieldFocused = false
			// сообщаем родителям
			this.$emit('blur', 'name')
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// функция анализирует значение доменного имени
		// и делает разделение на зону и имя домена
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		parseDomainNameValue(value) {
			// если ничего нет - ничего не делаем
			if (!value) return

			// если это не корректное доменное имя - ничего не делаем
			if (!Helper.validateHostnameForFQDN(value)) return

			// делим на зону и имя
			let parts = value.split('.')
			if (parts.length <= 1) return

			let zone = parts.pop()
			zone = String(zone).trim().toLowerCase()
			let domain = parts.join('.')

			// если есть зона и имя
			if (zone && zone.length > 1 && domain)
			{
				// меняем значение поля
				this.nameValue = domain.trim().toLowerCase()
				this.$emit('onDomainName', this.nameValue)

				// нужно выбрать или первое значение из списка зон
				// или поставить зону домена
				// бежим по списку
				let _item = null
				// если задан список тарифов (могут и не задать)
				if (this.items && this.items.length)
					// ищем значение
					this.items.some(item => {
						// первый элемент
						if (!_item) _item = item
						// ищем в списке заданное значение
						if (zone === String(item.name).toLowerCase())
						{
							_item = item
							return true
						}
					})

				// если значение найдено
				if (_item)
				{
					this.planValue = _item
					this.$emit('input', this.planValue && this.planValue.id ? this.planValue.id : null)
				}
			}
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		//
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		parseDomainNameValueDebounce(value) {
			this.parseDomainNameValue(value)
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// обработчик копирования из буфера в поле наименования домена
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onNamePaste(e) {
			// что скопировали из буфера
			let content = null

			// получим в зависимости от браузера
			if (e.clipboardData)
			{
				content = e.clipboardData.getData('text/plain')
			}
			else if (window.clipboardData)
			{
				content = window.clipboardData.getData('Text')
			}

			// парсим доменное имя
			this.parseDomainNameValue(content)
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// обработчик нажатия клавиши ENTER
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		enterKeyDown() {
			// сообщаем родителям
			this.$emit('keydownEnter')
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// обработчик открытия списка тарифов
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onListOpen() {
			// эмулация получения фокуса полем
			this.onNameFocus()
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// обработчик закрытия списка тарифов
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onListClose() {
			// эмулация потери фокуса полем
			this.onNameBlur()
			// сообщаем родителям
			this.$emit('blur', 'plan_id')
		},

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		// обработчик выбора тарифа
		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
		onPlanSelect(item) {
			// сообщаем родителю что у нас поменялось значение
			this.$emit('input', String(item.id))
		}

		//~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~ ~
	},

	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		// родитель поменял список значений
		'items': function(items, old) {
			// инициализируем, только если список изменился
			if (!Helper.arrayCompare(items, old)) this.Init()
		},
		// родитель поменял значение поля "set_action"
		'actionField.value': function(value, oldValue) {
			if (value !== oldValue)
				this.Init()
		}
	},

	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		Multiselect
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
.wrapper {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: space-between;
	-webkit-justify-content: space-between;

	align-items: center;
	-webkit-align-items: center;
	
	border: 1px solid #DDD;
	border-radius: 4px;
}
.wrapper.for-error {
	border: none;
	position: relative;
}
.wrapper.for-error > div.alert {
	top: 0;
	z-index: 13;
}
.wrapper.active {
    border-color: #66afe9;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, .6);
}
.wrapper.haserror {
	border: 1px solid #f72b2b !important;
}
.wrapper.haserror.active {
	box-shadow: inset 0 1px 1px rgba(0, 0, 0, .2), 0 0 6px #f79b9b;
}


.domains-name-field-wrapper {
	flex: 1;
	position: relative;
	width: 100%;
}

.domains-name-field-wrapper > span.dot {
	position: absolute;
	opacity: 0;
	top: 0;
	right: -7px;
	height: 45px;
	padding: 3px 0;
	font-weight: 500;
	line-height: 20px;
	font-size: 44px;
	color: #555;
	transition: opacity 0.2s;
}
.domains-name-field-wrapper > span.dot.active {
	opacity: 1;
}

.w5-field-placeholder {
	position: absolute;
	left: 20px;
	height: 45px;
	width: calc(100% - 30px);
	padding: 3px 0;
	line-height: 39px;
	font-weight: 400;
	color: #ccc;
	user-select: none;
	pointer-events: none;
	z-index: 0;
	text-align: right;
}
.w5-field-placeholder .required-field {
	color: #ccc;
}
.w5-field-placeholder.active {
	font-size: 75%;
	line-height: 1;
	color: #9f9f9f;
}
.w5-field-placeholder.active .required-field {
	color: red;
}
.w5-field-placeholder.readonly {
	z-index: 1;
}

.name-field {
	text-align: right;
}
.name-field, .name-field:focus {
	border: none !important;
	box-shadow: none !important;
	padding-right: 10px !important;
	padding-top: 0px !important;
	font-weight: 500 !important;
}

.domains-plan-option {
	font-weight: 300;
}

.domains-plan-label {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: space-between;
	-webkit-justify-content: space-between;

	align-items: center;
	-webkit-align-items: center;

	font-weight: 300;

	height: 45px;
}

.domains-plan-label > div.name {
	flex: 0 1 auto;
	font-size: 16px;
	margin-right: 7px;
	min-width: 30px;
}
.domains-plan-label > div.info {
	flex: 1;
	font-size: 13px;
	line-height: 1;

	display: flex;
	display: -webkit-box;
	display: -webkit-flex;

	justify-content: center;
	-webkit-justify-content: center;

	align-items: flex-start;
	-webkit-align-items: flex-start;

	flex-direction: column;
}
</style>


<style>
.domains-plan-field-wrapper {
	width: 50%;
	max-width: 320px;
	border-left: 1px solid #ddd;
	z-index: 14;
}

.domains-plan-field-wrapper > .domains-plan-field {
	width: 100%;
}
.domains-plan-field-wrapper > .domains-plan-field > .multiselect__tags {
	border: none;
	padding-top: 0;
}
.domains-plan-field-wrapper > .domains-plan-field > .multiselect__tags > .multiselect__single {
	padding-left: 1px;
}

</style>



// WEBPACK FOOTER //
// planDomain.vue?75b1409c